import * as types from "./actionTypes"

export function fetchChargeSummaries(data) {
    return {
        type: types.CHARGE_SUMMARIES_FETCH,
        payload: data,
    }
}
export function fetchChargeSummariesSuccess(data) {
    return {
        type: types.CHARGE_SUMMARIES_FETCH_SUCCESS,
        payload: data,
    }
}
export function fetchChargeSummariesFailure() {
    return {
        type: types.CHARGE_SUMMARIES_FETCH_FAILURE,
    }
}
export function fetchChargeDetails(data) {
    return {
        type: types.CHARGE_SUMMARIES_DETAILS_FETCH,
        payload: data,
    }
}
export function fetchChargeDetailsSuccess(data) {
    return {
        type: types.CHARGE_SUMMARIES_DETAILS_FETCH_SUCCESS,
        payload: data,
    }
}
export function fetchChargeDetailsFailure() {
    return {
        type: types.CHARGE_SUMMARIES_FETCH_FAILURE,
    }
}
export function clearSelectedSummary() {
    return {
        type: types.CLEAR_SELECTED_SUMMARY,
    }
}
export function updateSelectedSummary(data) {
    return {
        type: types.UPDATE_SELECTED_SUMMARY,
        payload: data,
    }
}
